import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2212_34035",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2212_34035)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.8833 19.9974 11.7641 19.9923 11.6423C19.9871 11.5204 19.9813 11.4115 19.975 11.3155C19.9108 11.7795 19.7098 12.1634 19.372 12.4672C19.0343 12.7711 18.6283 12.923 18.1538 12.923H15.8845C15.3768 12.923 14.9422 12.7424 14.5807 12.3813C14.2192 12.0199 14.0385 11.5856 14.0385 11.0782V10.1557H10.3463V8.311C10.3463 7.80367 10.527 7.36858 10.8885 7.00575C11.25 6.64292 11.6846 6.4615 12.1923 6.4615H13.1155V6.077C13.1155 5.64233 13.2469 5.28233 13.5098 4.997C13.7724 4.71183 14.0891 4.51283 14.4598 4.4C14.0686 4.27183 13.6698 4.17308 13.2635 4.10375C12.8572 4.03458 12.436 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12V12.1442C4 12.1891 4.00317 12.2372 4.0095 12.2885H8.75C9.773 12.2885 10.6442 12.6481 11.3635 13.3673C12.0827 14.0866 12.4423 14.9563 12.4423 15.9765V16.9038H9.673V19.6443C10.0448 19.7596 10.4237 19.8477 10.8095 19.9088C11.1955 19.9696 11.5923 20 12 20Z",
			fill: "white"
		})
	})]
});
export default SvgGlobe;
